// Import react elements
import React, { useEffect, useState } from "react";

// Import hooks
import usePageTitle from "global/hooks/usePageTitle";

import useCustomProductsData from "../hooks/useCustomProductsData";

// Import components
import { Grid, GridItem } from "global/components/Grid";
import MMMManager  from "./components/ManageMMMs";
import LinkMMMs  from "./components/LinkMMMs";

// PodProductsPage.js
const ManageMMMsPage = () => {



    // Set title inside the page
    usePageTitle("Manage Materials, Methods and Modes");




    // State for storing MMMs
    const [materials, setMaterials] = useState([]);
    const [methods, setMethods] = useState([]);
    const [modes, setModes] = useState([]); 

    // State for storing links
    const [links, setLinks] = useState([]); 

    // Set loading state - while api call is fetching links
    const [loadingLinks, setLoadingLinks] = useState(true);



    // Custom hook for fetching and managing pod design and product data
    const {
        fetchMMMs,
        fetchAndFormatCustomProductMMMLinks
    } = useCustomProductsData(); 



    // Function to refetch MMMs and then refetch+format links using those fresh MMMs
    const handleRefetchMMMsAndLinks = async (setMaterials, setMethods, setModes, setLinks, setLoadingLinks) => {

        // Await the MMM fetch and grab the fresh arrays directly
        const { materials, methods, modes } = await fetchMMMs(

            // Pass in the state setters
            setMaterials,
            setMethods,
            setModes

        );

        // Now pass the fresh MMM arrays into the formatter
        await fetchAndFormatCustomProductMMMLinks(

            // Setter for links
            setLinks,

            // Setter for loading
            setLoadingLinks,

            // Fresh materials
            materials,

            // Fresh methods
            methods,

            // Fresh modes
            modes

        );

    };


    // Load MMM data (materials, methods, modes) on mount
    useEffect(() => {

        // Call the async loader
        handleRefetchMMMsAndLinks(setMaterials, setMethods, setModes, setLinks, setLoadingLinks);

    // Dependency array is empty: only run once on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);






    return (

        <>

            <Grid>

                <GridItem>

                    <p>View, create and edit Materials, Methods and Modes. These can then be linked together and applied to custom products.</p>

                </GridItem>

            </Grid>

            <Grid>
                
                <GridItem>

                    {/* <ArrayManager /> */} 

                    <h3>Create / Edit Materials, Methods & Modes</h3>

                    <br/>

                    <MMMManager
                        materials={materials}
                        setMaterials={setMaterials}
                        methods={methods}
                        setMethods={setMethods}
                        modes={modes}
                        setModes={setModes}
                        setLinks={setLinks}
                        setLoadingLinks={setLoadingLinks}
                        handleRefetchMMMsAndLinks={handleRefetchMMMsAndLinks}
                        
                    />

                </GridItem>

            </Grid>


            <LinkMMMs
                materials={materials}
                setMaterials={setMaterials}
                methods={methods}
                setMethods={setMethods}
                modes={modes}
                setModes={setModes}
                links={links}
                setLinks={setLinks}
                loadingLinks={loadingLinks}
                setLoadingLinks={setLoadingLinks}
                handleRefetchMMMsAndLinks={handleRefetchMMMsAndLinks}
            />

        </>

    );

};

export default ManageMMMsPage;